import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import { msalInstance } from './authConfig';

async function initializeApp() {
    try {
        await msalInstance.initialize();
        console.log("✅ MSAL initialized successfully");

        // Handle redirect response properly
        msalInstance.handleRedirectPromise().then((response) => {
            if (response !== null && response.account) {
                console.log("✅ Authorization successful:", response);
                msalInstance.setActiveAccount(response.account);
            } else {
                const accounts = msalInstance.getAllAccounts();
                if (accounts.length > 0) {
                    msalInstance.setActiveAccount(accounts[0]);
                }
            }
        }).catch(error => {
            console.error("❌ Redirect error:", error);
        });

        const app = createApp(App);
        window.$msalInstance = msalInstance; // Make MSAL globally accessible

        app.config.globalProperties.$msalInstance = msalInstance;
        app.mount('#app');
    } catch (error) {
        console.error("❌ MSAL initialization failed:", error);
    }
}

initializeApp();
